// Serie de cada pieza de una línea rastreada (IMEI o serie): una caja por unidad del carrito.
import { cn } from '@/lib/cn';

const INPUT =
    'block h-7 w-full rounded-md border border-input bg-background px-2 font-mono text-[11.5px] outline-none placeholder:text-muted-foreground focus:border-ring';

export function PieceSerialInputs({
    name,
    qty,
    values,
    onChange,
}: {
    name: string;
    qty: number;
    values: readonly string[];
    onChange: (next: string[]) => void;
}) {
    const trimmed = values.slice(0, qty).map((v) => v.trim());
    const isRepeated = (idx: number): boolean =>
        trimmed[idx] !== '' && trimmed.indexOf(trimmed[idx]) !== idx;

    return (
        <fieldset className="col-span-2 flex flex-col gap-1">
            <legend className="mb-1 text-[10px] text-muted-foreground">
                Escanea o teclea la serie de cada pieza
            </legend>
            {Array.from({ length: qty }, (_, idx) => {
                const repeated = isRepeated(idx);
                return (
                    <div key={idx}>
                        <input
                            aria-label={`Serie de ${name}, pieza ${String(idx + 1)}`}
                            aria-invalid={repeated || undefined}
                            autoComplete="off"
                            placeholder={`Pieza ${String(idx + 1)}`}
                            value={values[idx] ?? ''}
                            onChange={(e) => {
                                const next = Array.from({ length: qty }, (_, i) => values[i] ?? '');
                                next[idx] = e.target.value;
                                onChange(next);
                            }}
                            className={cn(INPUT, repeated && 'border-destructive')}
                        />
                        {repeated && (
                            <p className="mt-0.5 text-[10px] text-destructive">
                                Esa serie ya está en otra pieza.
                            </p>
                        )}
                    </div>
                );
            })}
        </fieldset>
    );
}
